import { getUserDetails, makeGetCall, makePostCall } from './helper';

const STORAGE_KEY = 'mouse-click-actions';

const DEFAULT_MOUSE_ACTIONS = {
  leftClick: 'WindowLevel',
  rightClick: 'StackScroll',
  middleClick: 'Pan',
  scroll: 'StackScroll',
};

const isValidActions = obj =>
  obj && obj.leftClick && obj.rightClick && obj.middleClick && obj.scroll;

const writeLocal = actions => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(actions));
  } catch (e) {
    console.warn('mouseActionsApi: failed to write localStorage', e);
  }
};

const getUsername = () => {
  const u = getUserDetails();
  return u?.username || u?.user_name || null;
};

// Hydrate localStorage from backend before any viewer/tool-group code reads it.
// Safe to call when not logged in - it just no-ops.
export const preloadUserMouseActions = async () => {
  const username = getUsername();
  if (!username) return null;

  try {
    const resp = await makeGetCall(
      `/get-mouse-actions?username=${encodeURIComponent(username)}`
    );
    const actions = resp?.data?.data;
    if (isValidActions(actions)) {
      writeLocal(actions);
      return actions;
    }
  } catch (e) {
    // Non-fatal: viewer falls back to whatever is already in localStorage,
    // or to hard-coded defaults inside MouseActionsService / initToolGroups.
    console.warn('mouseActionsApi: preload failed, using local/default config', e);
  }
  return null;
};

// Persist to backend AND mirror into localStorage so existing consumers
// (initToolGroups, MouseActionsService) keep working without changes.
export const persistUserMouseActions = async actions => {
  const username = getUsername();
  const payload = { ...DEFAULT_MOUSE_ACTIONS, ...actions };

  writeLocal(payload);

  if (!username) return payload;

  try {
    await makePostCall('/save-mouse-actions', { username, ...payload });
  } catch (e) {
    console.error('mouseActionsApi: failed to persist mouse actions', e);
    throw e;
  }
  return payload;
};
